/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Nodatadescription2Inputs */

const id_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya game yang diluncurkan dengan kemajuan pencapaian publik yang muncul di profil.`)
};

const ms_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya permainan yang dilancarkan dengan kemajuan pencapaian awam muncul di profil.`)
};

const da_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun udgivne spil med offentlig achievement-fremskridt vises på profiler.`)
};

const de_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur veröffentlichte Spiele mit öffentlichem Errungenschaften-Fortschritt erscheinen in Profilen.`)
};

const en_us2_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only launched games with public achievement progress appear on profiles.`)
};

const es_es2_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo los juegos lanzados con progreso de logros público aparecen en los perfiles.`)
};

const es_mx2_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo los juegos lanzados con progreso de logros público aparecen en los perfiles.`)
};

const fil_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga nailabas na laro na may pampublikong progress ng achievement lamang ang lumalabas sa profile.`)
};

const fr_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuls les jeux lancés avec un progrès de succès public apparaissent sur les profils.`)
};

const it_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo i giochi pubblicati con progressi pubblici dei risultati appaiono sui profili.`)
};

const hu_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csak a nyilvános teljesítmény-előrehaladással rendelkező kiadott játékok jelennek meg a profilokon.`)
};

const nl_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen uitgebrachte games met openbare prestatievoortgang verschijnen op profielen.`)
};

const no_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bare utgitte spill med offentlig prestasjonsfremgang vises på profiler.`)
};

const pl_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko uruchomione gry z publicznym postępem osiągnięć pojawiają się na profilach.`)
};

const pt_br2_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas jogos lançados com progresso de conquista pública aparecem nos perfis.`)
};

const pt_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas jogos lançados com progresso público de conquistas aparecem nos perfis.`)
};

const ro_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar jocurile lansate cu progres public al realizărilor apar în profiluri.`)
};

const fi_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain julkaistut pelit, joissa on julkinen saavutusten edistyminen, näkyvät profiileissa.`)
};

const sv_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endast lanserade spel med offentlig prestationsframgång visas på profiler.`)
};

const vi_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ các game đã phát hành với tiến trình thành tích công khai mới xuất hiện trên hồ sơ.`)
};

const tr_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profillerde yalnızca halka açık başarım ilerlemesi olan yayınlanmış oyunlar görünür.`)
};

const cs_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na profilech se zobrazují pouze vydané hry s veřejným postupem úspěchů.`)
};

const bg_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Само пуснати игри с публичен напредък на постиженията се показват в профилите.`)
};

const ru_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В профилях отображаются только выпущенные игры с публичным прогрессом достижений.`)
};

const uk_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У профілях відображаються лише випущені ігри з публічним прогресом досягнень.`)
};

const ar_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فقط الألعاب التي تم إصدارها مع تقدم إنجازات عام يظهر في الملفات الشخصية.`)
};

const hi_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल लॉन्च किए गए गेम जिनमें सार्वजनिक उपलब्धि प्रगति है, प्रोफ़ाइल पर दिखाई देते हैं।`)
};

const th_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เฉพาะเกมที่วางจำหน่ายแล้วที่มีความคืบหน้าความสำเร็จสาธารณะเท่านั้นที่แสดงบนโปรไฟล์`)
};

const ja_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開実績の進行状況があるリリース済みゲームのみがプロフィールに表示されます。`)
};

const zh_cn2_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有已运行且有公开成就进度的游戏才会显示在档案中。`)
};

const zh_hant1_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有已執行且有公開成就進度的遊戲才會顯示在檔案中。`)
};

const ko_profile_showcase_nodatadescription2 = /** @type {(inputs: Profile_Showcase_Nodatadescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공개 도전 과제 진행 상황이 있는 출시된 게임만 프로필에 표시됩니다.`)
};

/**
* | output |
* | --- |
* | "Only launched games with public achievement progress appear on profiles." |
*
* @param {Profile_Showcase_Nodatadescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_nodatadescription2 = /** @type {((inputs?: Profile_Showcase_Nodatadescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Nodatadescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_nodatadescription2(inputs)
	if (locale === "ms") return ms_profile_showcase_nodatadescription2(inputs)
	if (locale === "da") return da_profile_showcase_nodatadescription2(inputs)
	if (locale === "de") return de_profile_showcase_nodatadescription2(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_nodatadescription2(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_nodatadescription2(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_nodatadescription2(inputs)
	if (locale === "fil") return fil_profile_showcase_nodatadescription2(inputs)
	if (locale === "fr") return fr_profile_showcase_nodatadescription2(inputs)
	if (locale === "it") return it_profile_showcase_nodatadescription2(inputs)
	if (locale === "hu") return hu_profile_showcase_nodatadescription2(inputs)
	if (locale === "nl") return nl_profile_showcase_nodatadescription2(inputs)
	if (locale === "no") return no_profile_showcase_nodatadescription2(inputs)
	if (locale === "pl") return pl_profile_showcase_nodatadescription2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_nodatadescription2(inputs)
	if (locale === "pt") return pt_profile_showcase_nodatadescription2(inputs)
	if (locale === "ro") return ro_profile_showcase_nodatadescription2(inputs)
	if (locale === "fi") return fi_profile_showcase_nodatadescription2(inputs)
	if (locale === "sv") return sv_profile_showcase_nodatadescription2(inputs)
	if (locale === "vi") return vi_profile_showcase_nodatadescription2(inputs)
	if (locale === "tr") return tr_profile_showcase_nodatadescription2(inputs)
	if (locale === "cs") return cs_profile_showcase_nodatadescription2(inputs)
	if (locale === "bg") return bg_profile_showcase_nodatadescription2(inputs)
	if (locale === "ru") return ru_profile_showcase_nodatadescription2(inputs)
	if (locale === "uk") return uk_profile_showcase_nodatadescription2(inputs)
	if (locale === "ar") return ar_profile_showcase_nodatadescription2(inputs)
	if (locale === "hi") return hi_profile_showcase_nodatadescription2(inputs)
	if (locale === "th") return th_profile_showcase_nodatadescription2(inputs)
	if (locale === "ja") return ja_profile_showcase_nodatadescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_nodatadescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_nodatadescription2(inputs)
	return ko_profile_showcase_nodatadescription2(inputs)
});
export { profile_showcase_nodatadescription2 as "profile.showcase.noDataDescription" }